import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { SystemMessageType } from '@portal-core/system-messages/enums/system-message-type.enum';
import { NgClass } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { StopPropagationDirective } from '@portal-core/general/directives/stop-propagation/stop-propagation.directive';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'mc-system-message-card',
    templateUrl: './system-message-card.component.html',
    styleUrls: ['./system-message-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, MatIconButton, StopPropagationDirective, MatIcon]
})
export class SystemMessageCardComponent implements OnInit {
  @Input() messageType = SystemMessageType.WhatsNew;
  @Input() title: string;
  @Input() message: string;

  @Output() cardClick = new EventEmitter();
  @Output() closeClick = new EventEmitter();

  icon: string;

  @Input() clickCardCallback = () => true;
  @Input() clickCloseCallback = () => false;

  constructor() { }

  ngOnInit() {
    this.icon = this.messageType === SystemMessageType.WhatsNew
      ? 'icon-gift'
      : 'icon-simon';
  }

  getMessageColorClassName(): string {
    return this.messageType === SystemMessageType.WhatsNew
      ? 'mc-whats-new-card'
      : 'mc-system-message-card';
  }

  onCardClick(): void {
    this.cardClick.emit(true);
  }

  onCloseClick(): void {
    this.closeClick.emit(false);
  }
}
